import {t} from "@lingui/core/macro";

/**
 * A helper that returns a status message based on the message content.
 * Right now, we only display these for a certain subset of incoming messages.
 * If we want to extend this functionality, we might want to pass a
 * Message instead of the text field.
 */
export function getMaybeStatusMessage(
    hadMathCheck: boolean,
    messageText: string,
) {
    // There's no message text. This should not happen, but just in case.
    if (!messageText) {
        return;
    }
    // "Waiting for math agent" state, IE "Doing math" followed by
    // the "three dots" unicode character signals
    // we have a long-running math check on the backend.
    if (messageText.includes("Doing math…")) {
        return t`Calculating`;
    }
    // Response has started or completed state.
    // Show the "check AI math" message.
    if (hadMathCheck) {
        return t`Remember to check AI math`;
    }
    // Fall through state: no math check, so no special message.
    return;
}
